import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      d: "M12 24A12 12 0 1 0 0 12a12 12 0 0 0 12 12m-4.74-7.46v-8A1.5 1.5 0 0 1 8.76 7h.48a1.5 1.5 0 0 1 1.5 1.5v8a1.5 1.5 0 0 1-1.5 1.5h-.48a1.5 1.5 0 0 1-1.5-1.46m6-8A1.5 1.5 0 0 1 14.71 7h.53a1.5 1.5 0 0 1 1.5 1.5v8a1.5 1.5 0 0 1-1.5 1.5h-.53a1.5 1.5 0 0 1-1.5-1.5Z"
    }, null, -1)
  ]));
}
const entertainmentControlButtonCirclePause = { render };
export {
  entertainmentControlButtonCirclePause as default,
  render
};
//# sourceMappingURL=entertainment-control-button-circle-pause.svg.js.map
